import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  model = [
    {
      name: "Berna Çağatay",
      statu: "Kurucu Ortak - CEO",
      "image": "about-us-images/berna-cagatay.jpg"
    },
    {
      name: "Taylan Tüfekçi",
      statu: "Kurucu Ortak - CTO",
      "image": "about-us-images/taylan-tüfekci.jpg"
    },
    {
      name: "Ebru Bilgin",
      statu: "Kurucu Ortak - CFO",
      "image": "about-us-images/ebru-bilgin.jpg"
    },
    {
      name: "Ayşe Yazgan",
      statu: "Pazarlama Yönetimi",
      "image": "about-us-images/ayse.jpg"
    },
    {
      name: "Bora Yüce",
      statu: "UI/UX Tasarım",
      "image": "about-us-images/bora-yuce.jpg"
    },
    {
      name: "Selen Sarı Pekin",
      statu: "Kurumsal İletişim Tasarımı",
      "image": "about-us-images/selen-sarıpekin.jpg"
    },
    {
      name: "Oğuz Kaan Yeşilbaş",
      statu: "Teknoloji & Yazılım Geliiştime",
      "image": "about-us-images/oguz-yesilbas.jpg"
    },
    {
      name: "İbrahim Dolapci",
      statu: "Teknoloji & Yazılım Geliiştime",
      "image": "about-us-images/ibrahim-dolapci.jpg"
    },
    {
      name: "Seren Irmak Bilge",
      statu: "İş Geliştirme & Veri Yönetimi",
      "image": "about-us-images/seren-ırmak-bilge.jpg"
    },
    {
      name: "Gizem Bora",
      statu: "Sosyal Medya İletişim Yönetimi",
      "image": "about-us-images/gizem-bora.jpg"
    },
    {
      name: "Feriha Saygınsoy",
      statu: "Görsel İletişim Tasarımı",
      "image": "about-us-images/selen-sarıkaya.jpg"
    }
  ];

  constructor(private meta: Meta, private title: Title) {
    this.title.setTitle('bigadvice - Hakkımızda');
    this.meta.addTags([
      { property: "og:title", content: 'How to use Angular 4 meta service' },
      { name: 'author', content: 'talkingdotnet' },
      { name: 'keywords', content: 'Angular, Meta Service' }
    ], true)

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/about-us/about-us.component.ts